<!-- eslint-disable max-len -->
<template>
	<div class="geo-search-wrapper">
		<h3>
			<span>Find more top doctors on</span>
			<a
				href="https://doctor.webmd.com"
				rel="nofollow"
			>
				<icons name="care-logo" />
			</a>
		</h3>
		<form
			class="geo-search"
			ref="geoForm"
			@submit.prevent="onSubmit"
		>
			<input
				type="hidden"
				v-if="campaignData && campaignData.specialties_queried"
				:value="campaignData.specialties_queried.join(',')"
				name="sids"
			/>
			<input
				type="hidden"
				:value="state"
				name="state"
			/>
			<input
				type="hidden"
				:value="city"
				name="city"
			/>
			<input
				type="hidden"
				:value="pt"
				name="pt"
			/>
			<type-ahead
				v-model="query"
				:trigger-on-focus="false"
				:trigger-at-length="3"
				@select="handleTermSelect"
				@changeInput="clearPopupError"
				tabindex="1001"
				popper-class="geo-search-region"
				matchwidth
				:fetch-suggestions="fetchSuggestions"
				placeholder="Zip Code or City, State"
				errormessage="The location you tried did not return a valid result. Please enter a valid location."
				:class="{ error }"
				:title="error"
			/>
			<Button
				type="primary"
				native-type="submit"
				icon="webmd-icon-search"
				class="submit-btn"
			>
				Search
			</Button>
		</form>
	</div>
</template>
<script>
import { TypeAhead, Button } from 'webmd-elements';
import Icons from './Icons.vue';
import { getZipcodeSuggestions } from './services.es6';

export default {
	name: 'SearchBar',
	components: {
		Icons,
		TypeAhead,
		Button,
	},
	data: () => ({
		query: '',
		city: '',
		state: '',
		pt: '',
		matchedLocs: [],
		error: '',
		inputChanged: false,
	}),
	props: {
		fallbackLocation: {
			type: Object,
			default: null,
		},
		campaignData: {
			type: Object,
			default: null,
		},
	},
	watch: {
		fallbackLocation(loc) {
			this.setLocFields(loc);
		},
	},
	methods: {
		setLocFields(loc) {
			if (loc) {
				this.city = loc.city;
				this.state = loc.state;
				this.query = `${loc.city}, ${loc.state} ${loc.zip}`;
				this.pt = `${loc.lat},${loc.lon}`;
			}
		},
		onSubmit(event) {
			if (event) {
				event.preventDefault();
			}
			const [city = '', state = ''] = (this.query || '').split(',').map((l) => l.trim());
			if (
				(
					(city && !new RegExp(city, 'gi').test(this.city))
					|| (state && !new RegExp(state, 'gi').test(this.state))
				)
				&& this.matchedLocs?.length
			) {
				const found = this.matchedLocs.find((loc) => {
					if (
						new RegExp(loc.city, 'gi').test(city)
					) {
						if (state && !new RegExp(loc.state, 'gi').test(state)) {
							return false;
						}
						return true;
					}
					return false;
				});
				if (found) {
					this.city = found.city;
					this.state = found.state;
					this.pt = `${found.lat},${found.lon}`;
					this.query = `${this.city}, ${this.state}`;
				} else {
					this.error = 'Please select a location from the list';
				}
			} else if (this.inputChanged && this.query && !this.matchedLocs?.length) {
				this.query = '';
				return;
			}
			try {
				const mmodule = 'pd-trav1';
				this.$vsetCookie('wb.pdicd', mmodule);
				this.$vwmdTrack(
					{
						moduleName: `${mmodule}_sub`,
					},
				);
			} catch (e) {
				// eslint-disable-next-line no-console
				console.log('Omniture error', e);
			} finally {
				if (!this.error && this.city && this.state && this.pt) {
					const params = new URLSearchParams({
						city: this.city,
						state: this.state,
						pt: this.pt,
						sids: this.campaignData.specialties_queried?.join(','),
					}).toString();

					window.location.href = `https://doctor.webmd.com/results?${params}`;
				}
			}
		},
		clearPopupError() {
			this.inputChanged = true;
			this.error = '';
			this.matchedLocs = [];
		},
		handleTermSelect(res) {
			if (res?.type !== 'select') {
				this.city = res.city;
				this.state = res.state;
				this.pt = `${res.lat},${res.lon}`;
				this.onSubmit();
			}
		},
		fetchSuggestions(query, callback) {
			this.error = '';
			this.query = query;
			this.matchedLocs = [];
			this.inputChanged = true;
			getZipcodeSuggestions({ type: 'zipcode', q: query })
				.then((resp) => {
					if (
						resp?.types?.length
						&& resp?.types?.[0]?.references?.length
					) {
						this.matchedLocs = resp.types[0].references.map((item) => {
							const tempObj = {
								type: 'text',
								styles: '',
								link: '',
							};
							tempObj.lat = item.lat || '40.7396';
							tempObj.lon = item.lon || '-74.0007';
							tempObj.name = item.text || '';
							tempObj.value = `${item.city}, ${item.state}${
								item.zip ? ` ${item.zip}` : ''
							}`;
							tempObj.show = `${item.city}, ${item.state}${
								item.zip ? ` ${item.zip}` : ''
							}`;
							tempObj.show = tempObj.show.replace(
								new RegExp(`(${query})`, 'ig'),
								'<strong>$1</strong>',
							);
							tempObj.city = item.city;
							tempObj.state = item.state;
							if (!Number.isNaN(item.id)) {
								tempObj.zip = item.id;
							}
							return tempObj;
						});
						return this.matchedLocs;
					}
					return [];
				})
				.then((results) => {
					callback(results);
				});
		},
	},
	mounted() {
		this.setLocFields(this.fallbackLocation);
	},
};
</script>
<style lang="scss">

.geo-search-region {
	ul li {
		padding: 6px 15px 6px;
		line-height: 20px;
		cursor: pointer;
		width: 100%;

		& strong {
			color: #0078bf;
		}
	}

	.webmd-autocomplete-suggestion--no-option {
		span {
			white-space: pre-wrap;
		}
	}
}

.webmd-typeahead .webmd-input__inner {
	color: var(--care-text-black) !important;
}

.geo-search-wrapper {
	display: flex;
	align-items: center;
	justify-content: center;

	@media screen and (max-width: 767px) {
		flex-direction: column;
	}

	h3 {
		font-weight: 600;
		font-size: 24px;
		line-height: 34px;
		color: var(--care-text-white);
		margin: 0;
		margin-right: 12px;

		@media screen and (max-width: 1023px) {
			font-size: 16px;
			line-height: 34px;
			margin: 0;
			margin-right: 12px;
		}

		@media screen and (max-width: 767px) {
			font-size: 18px;
			line-height: 34px;
		}

		svg {
			margin-left: 6px;
			height: 20px;
			width: auto;

			@media screen and (max-width: 1023px) {
				height: 16px;
			}
		}
	}

	.geo-search {
		display: inline-flex;
		align-items: center;
		justify-content: center;

		.webmd-typeahead {
			height: 45px;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			&.error .webmd-input__div input {
				border: 1px solid red;
			}

			.webmd-input__div input {
				background: transparent;
				height: 45px;
				border: 0;
				background-color: #fff;
				border-radius: 0;
				border-start-start-radius: 4px;
				border-end-start-radius: 4px;

				&:focus {
					box-shadow: inset 0 0 2px #7bc6ff;
				}
			}
		}

		.submit-btn {
			background-color: var(--care-text-lightblue);
			height: 45px;
			border-start-start-radius: 0;
			border-end-start-radius: 0;

			&:hover {
				// --care-text-lightblue
				background-color: darken($color: #3557ff, $amount: 10%);
			}
		}
	}
}
</style>
